const BreakableText = ({ text, className = '' }) => {
  return <span className={className} dangerouslySetInnerHTML={{ __html: text }} />;
};

export default BreakableText;
